module.exports = __webpack_public_path__ + "static/img/email_selec.82062182.svg";